module.exports = __webpack_public_path__ + "img/blue_side_arrow.2b45128d.svg";